import { Component, Input } from '@angular/core';
import { CommonService } from 'src/app/core/services/common.service';

export interface DARPANRecord extends Record<string, unknown> {
  actName: string;
  address: string;
  darpanId: string;
  districtName: string;
  emailDecrypt: string;
  latitude: string;
  longitude: string;
  mobileDecrypt: string;
  ngoName: string;
  ngoType: string;
  ngoUrl: string;
  pincode: string;
  regAuthority: string;
  registrationDate: string;
  registrationNo: string;
  stateName: string;
  subDistrictName: string;
  submitDate: string;
  matchConfidence: string;
}

@Component({
  selector: 'app-darpan-compliance-card',
  templateUrl: './darpan-compliance-card.component.html',
  styleUrls: ['./darpan-compliance-card.component.scss']
})
export class DarpanComplianceCardComponent {
  @Input() darpanMatches: DARPANRecord[] = [];
  @Input() syncDate?: string;

  constructor(private commonService: CommonService) { }

  get hasMatches(): boolean {
    return this.darpanMatches && this.darpanMatches.length > 0;
  }

  get firstMatch(): DARPANRecord | null {
    return this.hasMatches ? this.darpanMatches[0] : null;
  }

  get formattedSyncDate(): string {
    if (!this.syncDate) {
      return '';
    }
    return this.formatDate(this.syncDate);
  }

  formatDate(date: string): string {
    if (!date) return 'N/A';
    try {
      const dateObj = new Date(date);
      return this.commonService.dateFormatter(dateObj.toISOString());
    } catch {
      return "N/A";
    }
  }
}

